<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <div *ngIf="!loading" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 *ngIf="newAssessment" class="h3 mb-0 text-gray-800">ELI Assessments</h1>
                    <h1 *ngIf="!newAssessment" class="h3 mb-0 text-gray-800">{{name}}</h1>
                    <div class="btns-container">
                        <!--<div class="margin-right-5">
                            <a [routerLink]="['/app/eli']" class="btn btn-red shadow-sm">
                                <i class="fas fa-trash-alt text-white-50"> <span class="button-text">Delete</span></i>
                            </a>
                        </div>-->
                        <div class="margin-right-5">
                            <a (click)="previewMode()" class="btn btn-other shadow-sm">
                                <i class="fas fa-eye text-white-50"> <span class="button-text">Preview</span></i>
                            </a>
                        </div>
                        <div>
                            <a (click)="saveAssessment()" class="btn btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div *ngIf="!loading" class="card shadow">
                    <div class="c-content padding15">
                        <div class="row">
                            <div class="col-md-2 text-right">
                                <label>Name: </label>
                            </div>
                            <div class="col-md-10">
                                <input #namee
                                       (keypress)="preventSpace(namee.value, $event)"
                                       (keyup)="preventSpace(namee.value, $event)"
                                       type="text" id="name" name="name" value="{{name}}" />
                            </div>
                        </div>

                        <!--<div class="row">
                <div class="col-md-2 text-right">
                    <label>Niche: </label>
                </div>
                <div class="col-md-10">
                    <select id="niche">
                        <option *ngFor="let niche of niches" [selected]="nicheName == niche.Name || nicheId == niche.Id" value="{{niche.Id}}">{{niche.Name}}</option>
                    </select>
                </div>
            </div>-->

                        <div class="row">
                            <div class="col-md-2 text-right">
                                <label>Version: </label>
                            </div>
                            <div class="col-md-10">
                                <input (keypress)="preventLetters($event)" class="small" type="number" name="name" min="1" value="{{majorVersion}}" id="major" />
                                <span class="dot"><b>.</b></span>
                                <input (keypress)="preventLetters($event)" class="small" type="number" name="name" min="0" value="{{minorVersion}}" id="minor" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2 text-right ">
                                <label for="price">Price: </label>
                            </div>
                            <div class="col-md-10 ">
                                <input #price
                                       (keyup)="validateDecimal(price.value)"
                                       type="number"
                                       name="price"
                                       min="1"
                                       step='0.01'
                                       placeholder='0.00'
                                       value=""
                                       [(ngModel)]="assessmentPrice"
                                       id="price"
                                       pattern="[0-9]+([\.,][0-9]+)?" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2 text-right ">
                                <label>Assessment 360: </label>
                            </div>
                            <div class="col-md-10 ">

                                <div class="checkbox">
                                    <input (change)="toggleAssessment360()" type="checkbox" value="" id="checkbox2" data-toggle="checkbox" [checked]="showAssessment360">
                                    <label style="position: relative;top: -13px;" for="checkbox2"></label>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!loading" class="c-content cTopSpacing">
                    <div class="responsiveTabs">
                        <select id="responsiveSelect" #t (change)="openTab(t.value)">
                            <option value="0-menu0">Regular section</option>
                            <option value="1-menu1">Satisfaction section</option>
                            <option value="2-menu2">Survey section</option>
                            <option value="3-menu3" *ngIf="showAssessment360">360</option>
                            <option value="4-menu4">Templates</option>
                            <option value="5-menu5">Pages</option>
                        </select>
                    </div>

                    <div class="desktopTabs">
                        <ul class="tab-nav">
                            <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#menu0">Regular section</a></li>
                            <li (click)="tabSelect(1)"><a data-toggle="tab" href="#menu1">Satisfaction section</a></li>
                            <li (click)="tabSelect(2)"><a data-toggle="tab" href="#menu2">Survey section</a></li>
                            <li (click)="tabSelect(3)" *ngIf="showAssessment360"><a data-toggle="tab" href="#menu3">360</a></li>
                            <li (click)="tabSelect(4)"><a data-toggle="tab" href="#menu4">Templates</a></li>
                            <li (click)="tabSelect(5)"><a data-toggle="tab" href="#menu5">Pages</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="menu0" class="tab-pane fade in active">
                            <div class="text-right absolute table-actions-buttons">
                                <!--<i (click)="showQuestions(1)" class="material-icons">add</i>
                    <button (click)="showQuestions(1)" class="btn" type="button">Add question</button>-->

                                <a (click)="showQuestions(1)" class="btn btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text">Add question</span></i>
                                </a>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <label>Choice set: </label>
                                </div>
                                <div class="col-md-8">
                                    <select id="rChoiceSet" #regularChoiceSet (change)="selectSectionChoiceSet(1, regularChoiceSet.value)">
                                        <option *ngFor="let choiceSet of regularChoiceSets" [selected]="rChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                    </select>
                                </div>
                            </div>

                            <br />

                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #regularQuestionsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="regularGridOptions"
                                                 [rowData]="regular_questions"
                                                 [columnDefs]="regularHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onRegularRowClicked($event)"
                                                 (gridReady)="onRegularGridReady($event)"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [animateRows]="true"
                                                 [rowDragManaged]="true"
                                                 (rowDragEnter)="onRowDragEnter($event)"
                                                 (rowDragEnd)="onRowDragEnd($event, regular_questions)">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div id="menu1" class="tab-pane fade">
                            <div class="text-right absolute table-actions-buttons">
                                <!--<i (click)="showQuestions(2)" class="material-icons">add</i>-->
                                <a (click)="showQuestions(2)" class="btn btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text">Add question</span></i>
                                </a>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <label>Choice set: </label>
                                </div>
                                <div class="col-md-8">
                                    <select id="sChoiceSet" #satisfactionChoiceSet (change)="selectSectionChoiceSet(2, satisfactionChoiceSet.value)">
                                        <option *ngFor="let choiceSet of satisfactionChoiceSets" [selected]="sChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                    </select>
                                </div>
                            </div>

                            <br />

                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #satisfactionQuestionsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="satisfactionGridOptions"
                                                 [rowData]="satisfaction_questions"
                                                 [columnDefs]="satisfactionHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onSatisfactionRowClicked($event)"
                                                 (gridReady)="onSatisfactionGridReady($event)"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [animateRows]="true"
                                                 [rowDragManaged]="true"
                                                 (rowDragEnter)="onRowDragEnter($event)"
                                                 (rowDragEnd)="onRowDragEnd($event, satisfaction_questions)">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div id="menu2" class="tab-pane fade">
                            <div class="text-right absolute table-actions-buttons">
                                <!--<i (click)="showQuestions(3)" class="material-icons">add</i>-->
                                <a (click)="showQuestions(3)" class="btn btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text">Add question</span></i>
                                </a>
                            </div>
                            <div class="" style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #surveyQuestionsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="surveyGridOptions"
                                                 [rowData]="survey_questions"
                                                 [columnDefs]="surveyHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onSurveyRowClicked($event)"
                                                 (gridReady)="onSurveyGridReady($event)"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [animateRows]="true"
                                                 [rowDragManaged]="true"
                                                 (rowDragEnter)="onRowDragEnter($event)"
                                                 (rowDragEnd)="onRowDragEnd($event, survey_questions)">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div id="menu3" class="tab-pane fade">
                            <div>
                                <ul class="nav nav-tabs">
                                    <li (click)="tabSelect(3.1)" id="section1" class="active"><a data-toggle="tab" href="#tab1">Section 1</a></li>
                                    <li (click)="tabSelect(3.2)"><a data-toggle="tab" href="#tab2">Section 2</a></li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div id="tab1" class="tab-pane fade in active">
                                    <div class="text-right absolute table-actions-buttons">
                                        <!--<i (click)="showQuestions(4)" class="material-icons">add</i>-->
                                        <a (click)="showQuestions(4)" class="btn btn-primary shadow-sm">
                                            <i class="fas fa-plus text-white-50"> <span class="button-text">Add question</span></i>
                                        </a>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Choice set: </label>
                                        </div>
                                        <div class="col-md-8">
                                            <select id="section1ChoiceSet" #section1ChoiceSet (change)="selectSectionChoiceSet(4, section1ChoiceSet.value)">
                                                <option *ngFor="let choiceSet of section1ChoiceSets" [selected]="section1currentChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <br />

                                    <div style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #section1QuestionsGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="false"
                                                         [gridOptions]="section1GridOptions"
                                                         [rowData]="section1_questions"
                                                         [columnDefs]="section1Headers"
                                                         [enableSorting]="false"
                                                         [enableColResize]="false"
                                                         (rowClicked)="onSection1RowClicked($event)"
                                                         (gridReady)="onSection1GridReady($event)"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [animateRows]="true"
                                                         [rowDragManaged]="true"
                                                         (rowDragEnter)="onRowDragEnter($event)"
                                                         (rowDragEnd)="onRowDragEnd($event, section1_questions)">
                                        </ag-grid-angular>
                                    </div>
                                </div>

                                <div id="tab2" class="tab-pane fade">
                                    <div class="text-right absolute table-actions-buttons">
                                        <!--<i (click)="showQuestions(5)" class="material-icons">add</i>-->
                                        <a (click)="showQuestions(5)" class="btn btn-primary shadow-sm">
                                            <i class="fas fa-plus text-white-50"> <span class="button-text">Add question</span></i>
                                        </a>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Choice set: </label>
                                        </div>
                                        <div class="col-md-8">
                                            <select id="section2ChoiceSet" #section2ChoiceSet (change)="selectSectionChoiceSet(5, section2ChoiceSet.value)">
                                                <option *ngFor="let choiceSet of section2ChoiceSets" [selected]="section2currentChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <br />

                                    <div style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #section2QuestionsGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="false"
                                                         [gridOptions]="section2GridOptions"
                                                         [rowData]="section2_questions"
                                                         [columnDefs]="section2Headers"
                                                         [enableSorting]="false"
                                                         [enableColResize]="false"
                                                         (rowClicked)="onSection2RowClicked($event)"
                                                         (gridReady)="onSection2GridReady($event)"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [animateRows]="true"
                                                         [rowDragManaged]="true"
                                                         (rowDragEnter)="onRowDragEnter($event)"
                                                         (rowDragEnd)="onRowDragEnd($event, section2_questions)">
                                        </ag-grid-angular>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="panel-group" id="mainAccordion">

                    <div class="panel panel-default">
                        <div class="panel-heading fieldsTitle" data-toggle="collapse" data-parent="#mainAccordion" href="#collapse">
                            <ul class="" (click)="sizeToFit(section1GridApi)">
                                <li>
                                    Section 1
                                </li>
                            </ul>
                        </div>
                        <div id="collapse" class="panel-collapse collapse">

                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                            <ul class="" (click)="sizeToFit(section2GridApi)">
                                <li>
                                    Section 2
                                </li>
                            </ul>
                        </div>

                        <div id="collapseEditor" class="panel-collapse collapse">

                        </div>
                    </div>
                </div>-->

                        </div>
                        <div id="menu4" class="tab-pane fade">

                            <div>
                                <ul class="nav nav-tabs">
                                    <li class="active"><a data-toggle="tab" href="#templatesTab1">Client</a></li>
                                    <li><a data-toggle="tab" href="#templatesTab2">Rater</a></li>
                                    <li><a data-toggle="tab" href="#templatesTab3">Coach</a></li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div id="templatesTab1" class="tab-pane fade in active">
                                    <!--client-->
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Invitation: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="clientInvitation" [(ngModel)]="clientInvitation" ng-init="1">
                                                    <option *ngFor="let ci of clientInvitations" value="{{ci.Id}}">{{ci.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Reminder: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="clientReminder" [(ngModel)]="clientReminder">
                                                    <option *ngFor="let cr of clientReminders" value="{{cr.Id}}">{{cr.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Result: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="clientResult" [(ngModel)]="clientResult">
                                                    <option *ngFor="let cr of clientResults" value="{{cr.Id}}">{{cr.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Result Available: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="clientResultAvailable" [(ngModel)]="clientResultAvailable">
                                                    <option *ngFor="let cra of clientResultsAvailable" value="{{cra.Id}}">{{cra.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Report: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select [(ngModel)]="clientTemplateId" id="clientTemplateId">
                                                    <option *ngFor="let clire  of clientReports" value="{{clire.Id}}">{{clire.Name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="templatesTab2" class="tab-pane fade">
                                    <!--rater-->
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Invitation: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="raterInvitation" [(ngModel)]="raterInvitation">
                                                    <option *ngFor="let ri of raterInvitations" value="{{ri.Id}}">{{ri.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Reminder: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="raterReminder" [(ngModel)]="raterReminder">
                                                    <option *ngFor="let rr of raterReminders" value="{{rr.Id}}">{{rr.Name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="templatesTab3" class="tab-pane fade">
                                    <!--coach-->
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Result: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select id="coachResult" [(ngModel)]="coachResult">
                                                    <option *ngFor="let cor of coachResults" value="{{cor.Id}}">{{cor.Name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Report: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <select [(ngModel)]="coachTemplateId" id="coachTemplateId">
                                                    <option *ngFor="let core of coachReports" value="{{core.Id}}">{{core.Name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="row">
                    <div class="col-md-2">
                        <label>Client report: </label>
                    </div>
                    <div class="col-md-10">
                        <select id="clientTemplateId">
                            <option value="0">0</option>
                            <option *ngFor="let report of clientReports" [selected]="clientTemplateId == report.Id" value="{{report.Id}}">{{report.Name}}</option>
                            <option value="1">1</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2">
                        <label>Coach report: </label>
                    </div>
                    <div class="col-md-10">
                        <select id="coachTemplateId">
                            <option value="0">0</option>
                            <option *ngFor="let report of coachReports" [selected]="coachTemplateId == report.Id" value="{{report.Id}}">{{report.Name}}</option>
                            <option value="1">1</option>
                        </select>
                    </div>
                </div>-->

                        </div>
                        <div id="menu5" class="tab-pane fade">

                            <div>
                                <ul class="nav nav-tabs" id="cPages">
                                    <li (click)="pageSelectedType(3)" class="active"><a data-toggle="tab" href="#pagesTab1">Client</a></li>
                                    <li *ngIf="showAssessment360" (click)="pageSelectedType(4)"><a data-toggle="tab" href="#pagesTab1">Rater</a></li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div id="pagesTab1" class="tab-pane fade in active">
                                    <!--client-->
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Type</label>
                                            </div>
                                            <div class="col-md-10">
                                                <select #page id="pageType" (change)="getAssessmentPageByUserType(page.value, lang.value, currentPageSelectedType)" [(ngModel)]="selectPageType">
                                                    <option *ngFor="let pageType of pageTypes" value="{{pageType.Id}}">{{pageType.Name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label> Language</label>
                                            </div>
                                            <div class="col-md-10">
                                                <select #lang id="language" (change)="getAssessmentPageByUserType(page.value, lang.value, currentPageSelectedType)" [(ngModel)]="selectLanguage">
                                                    <option *ngFor="let language of languages" value="{{language.ShortCode}}">{{language.Name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="panel panel-default">
                                        <div class="panel-heading" data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                                    Body
                                                </a>
                                            </h4>
                                        </div>

                                        <div id="collapseEditor" class="panel-collapse collapse in">
                                            <div class="panel-body">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <div class="body-content">
                                                            <!--<button (click)="insertCustomText()">insert text</button>
                                                <button (click)="insertCustomImages()">insert images</button>-->

                                                            <br />
                                                            <!--[options]="editorOptions"-->
                                                            <quill-editor #editor
                                                                          [(ngModel)]="editorContent"
                                                                          (blur)="onEditorBlured($event)"
                                                                          (focus)="onEditorFocused($event)"
                                                                          (onEditorCreated)="onEditorCreated($event)"
                                                                          (onContentChanged)="onContentChanged($event)"></quill-editor>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="customFields">
                                                            <div class="panel-group" id="accordion">

                                                                <div *ngFor="let field of templateFields; let i = index" class="panel panel-default">
                                                                    <div class="panel-heading" data-toggle="collapse">
                                                                        <h4 class="panel-title">
                                                                            <a data-toggle="collapse" data-parent="#accordion" href="#group{{i}}">{{field.Name}} Fields</a>
                                                                        </h4>
                                                                    </div>
                                                                    <div id="group{{i}}" class="panel-collapse collapse" [ngClass]="{'in': i == 0}">
                                                                        <div class="panel-body">
                                                                            <ul>
                                                                                <li *ngFor="let item of field.Fields">
                                                                                    <button (click)="insertCustomFields(item.Name)">{{item.Name}}</button>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<div class="desktopTabs">
                <ul class="nav nav-tabs">
                    <li class="active"><a data-toggle="tab" href="#section1">Section 1</a></li>
                    <li><a data-toggle="tab" href="#section2">Section 2</a></li>
                </ul>

                <div class="tab-content">
                    <div id="section1" class="tab-pane fade in active">

                    </div>
                    <div id="section2" class="tab-pane fade">

                </div>
            </div>
        </div>-->
                    <!--<tabset (onSelect)="tabSelect($event)">
        <tab title="">
        <span *tabHeading>
            <b style="color: deepskyblue">Regular section</b>
        </span>
        <div class="border">
            <!--<div class="text-right absolute">
                <i (click)="showQuestions(1)" class="material-icons">add</i>
            </div>

            <div class="row">
                <div class="col-md-2">
                    <label>Choice set: </label>
                </div>
                <div class="col-md-8">
                    <select id="rChoiceSet" #regularChoiceSet (change)="selectSectionChoiceSet(1, regularChoiceSet.value)">
                        <option *ngFor="let choiceSet of regularChoiceSets" [selected]="rChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                    </select>
                </div>
            </div>

            <br />

            <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                <ag-grid-angular #regularQuestionsGrid
                                    style="width: 100%; height: 100%;"
                                    class="ag-theme-balham"
                                    [enableFilter]="false"
                                    [gridOptions]="regularGridOptions"
                                    [rowData]="regular_questions"
                                    [columnDefs]="regularHeaders"
                                    [enableSorting]="false"
                                    [enableColResize]="false"
                                    (rowClicked)="onRegularRowClicked($event)"
                                    (gridReady)="onRegularGridReady($event)"
                                    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                    [animateRows]="true"
                                    [rowDragManaged]="true"
                                    (rowDragEnter)="onRowDragEnter($event)"
                                    (rowDragEnd)="onRowDragEnd($event, regular_questions)">
                </ag-grid-angular>
            </div>-->
                    <!--</div>
        </tab>
        <tab title="">
        <span *tabHeading>
            <b style="color: deepskyblue">Satisfaction section</b>
        </span>
        <div class="border">-->
                    <!--<div class="text-right absolute">
        <i (click)="showQuestions(2)" class="material-icons">add</i>
        </div>

        <div class="row">
        <div class="col-md-2">
            <label>Choice set: </label>
        </div>
        <div class="col-md-8">
            <select id="sChoiceSet" #satisfactionChoiceSet (change)="selectSectionChoiceSet(2, satisfactionChoiceSet.value)">
                <option *ngFor="let choiceSet of satisfactionChoiceSets" [selected]="sChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
            </select>
        </div>
        </div>

        <br />

        <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
        <ag-grid-angular #satisfactionQuestionsGrid
                            style="width: 100%; height: 100%;"
                            class="ag-theme-balham"
                            [enableFilter]="false"
                            [gridOptions]="satisfactionGridOptions"
                            [rowData]="satisfaction_questions"
                            [columnDefs]="satisfactionHeaders"
                            [enableSorting]="false"
                            [enableColResize]="false"
                            (rowClicked)="onSatisfactionRowClicked($event)"
                            (gridReady)="onSatisfactionGridReady($event)"
                            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                            [animateRows]="true"
                            [rowDragManaged]="true"
                            (rowDragEnter)="onRowDragEnter($event)"
                            (rowDragEnd)="onRowDragEnd($event, satisfaction_questions)">
        </ag-grid-angular>
        </div>-->
                    <!--</div>
        </tab>
        <tab title="">
        <span *tabHeading>
            <b style="color: deepskyblue">Survey section</b>
        </span>
        <div class="border">-->
                    <!--<div class="text-right">
        <i (click)="showQuestions(3)" class="material-icons">add</i>
        </div>
        <div class="" style="width: 100%; max-height: 400px; height:400px;">
        <ag-grid-angular #surveyQuestionsGrid
                            style="width: 100%; height: 100%;"
                            class="ag-theme-balham"
                            [enableFilter]="false"
                            [gridOptions]="surveyGridOptions"
                            [rowData]="survey_questions"
                            [columnDefs]="surveyHeaders"
                            [enableSorting]="false"
                            [enableColResize]="false"
                            (rowClicked)="onSurveyRowClicked($event)"
                            (gridReady)="onSurveyGridReady($event)"
                            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                            [animateRows]="true"
                            [rowDragManaged]="true"
                            (rowDragEnter)="onRowDragEnter($event)"
                            (rowDragEnd)="onRowDragEnd($event, survey_questions)">
        </ag-grid-angular>
        </div>-->
                    <!--</div>
        </tab>
        <tab title="">
        <span *tabHeading>
            <b style="color: deepskyblue">Templates</b>
        </span>
        <div class="border">-->
                    <!--<div class="row">
        <div class="col-md-2">
            <label>Client report: </label>
        </div>
        <div class="col-md-8">
            <select id="templateId">
                <option *ngFor="let template of templates" [selected]="templateId == template.Id" value="{{template.Id}}">{{template.Name}}</option>
            </select>
        </div>
        </div>-->
                    <!--</div>
        </tab>
        </tabset>-->
                </div>
            </div>
        </div>
    </div>
</div>

<!--MODAL-->
<div class="modal fade" id="questionsModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h2 class="modal-title text-center" id="">{{questionType}} questions</h2>
            </div>
            <div class="modal-body">
                <div class="" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #questionsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="questionsGridOptions"
                                     [rowData]="questions"
                                     [columnDefs]="questionsHeaders"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     (rowClicked)="onQuestionsRowClicked($event)"
                                     (gridReady)="onQuestionsGridReady($event)"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     [rowSelection]="rowSelection">
                    </ag-grid-angular>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="addQuestions()">Add</button>
            </div>
        </div>
    </div>
</div>

<app-new-regular-modal #newregular></app-new-regular-modal>
<app-new-satisfaction-modal #newsatisfaction></app-new-satisfaction-modal>
<app-new-survey-modal #newsurvey></app-new-survey-modal>
